import cx from 'classnames';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import defaultBodyStyles from './bodyStylesList';
import BodyStyleTile from './BodyStyleTile';
import DefaultSuggestionClicked from '../../../contracts/DefaultSuggestionClicked';
import { useWillNavigateToSearch } from '../../../SearchBarContext';
import {
  SectionTitle,
  SuggestionSectionContainer,
  modalStyles
} from '../DefaultSuggestions.styles';

type OwnProps = {
  inModal: boolean;
  handleDefaultSuggestionClicked: DefaultSuggestionClicked;
};

function calculateCardWidth(containerWidth: number) {
  // Divide the container width minus 16px left padding by 3.5 (3 cards fully visible + 50% of the fourth one)
  return (containerWidth - 16) / 3.5;
}

export default function DefaultBodyStyles({
  inModal,
  handleDefaultSuggestionClicked
}: OwnProps) {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [gridCols, setGridCols] = useState(6);
  const wrapperWidth = wrapperRef.current?.clientWidth;
  const showViewAll = useWillNavigateToSearch();
  const [cardWidth, setCardWidth] = useState(100);

  useEffect(() => {
    if (wrapperWidth) {
      const cols = Math.floor(wrapperWidth / 138);
      setGridCols(cols);

      if (inModal) setCardWidth(calculateCardWidth(wrapperWidth));
    }
  }, [inModal, wrapperWidth]);

  const bodyStylesToShow = useMemo(
    () =>
      showViewAll
        ? defaultBodyStyles
        : defaultBodyStyles.filter(bodyStyle => bodyStyle.text !== 'View all'),
    [showViewAll]
  );

  return (
    <SuggestionSectionContainer>
      <SectionTitle className={inModal ? 'pl-16' : ''}>
        Vehicle Styles
      </SectionTitle>
      <div
        ref={wrapperRef}
        className={cx('w-full gap-8', inModal ? `flex ${modalStyles}` : 'grid')}
        style={{
          gridTemplateColumns: inModal
            ? undefined
            : `repeat(${gridCols}, minmax(0,1fr))`
        }}
      >
        {bodyStylesToShow.map(bodyStyle => (
          <BodyStyleTile
            key={bodyStyle.text}
            bodyStyle={bodyStyle}
            handleDefaultSuggestionClicked={handleDefaultSuggestionClicked}
            isViewAllTile={bodyStyle.text === 'View all'}
            width={cardWidth}
          />
        ))}
      </div>
    </SuggestionSectionContainer>
  );
}
